import * as React from "react";
import Section from "../Layout/Section";
import Media from "../Common/Media";
import * as styles from "./clients.module.css";

const Clients = ({logos}) => {
    return (
        <Section title="Нам доверяют 400+ компаний">
            <div className={styles.clients__list}>
                {logos.map(({id, ...logo}) => (
                    <div className={styles.clients__logoWrapper} key={id}>
                        <Media
                            className={styles.clients__logo}
                            media={{content: logo}}
                            imageProps={{imgClassName: styles.clients__logoImage}}
                        />
                    </div>
                ))}
            </div>
        </Section>
    );
};

export default Clients;
